/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ItalicIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M16 7.5c0-.812.625-1.5 1.5-1.5h13c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-4.312L17 31h5.5c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-13c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5h4.25l9.188-22H17.5c-.875 0-1.5-.625-1.5-1.5"/>}
        </IconWrapper>);
}
